import { z } from 'zod';
export const emailSignatureLicenseSchema = z.object({
    name: z.string(),
    value: z.string(),
    hide: z.boolean().optional(),
});
